import type { IdentityProviders } from "mws-ts-v2-sdk";

import { useTeamContext } from "./useTeamContext";

export const useClubSso = () => {
  const { teamName } = useTeamContext();
  const customProviders = useCustomProviders();

  return computed(() => {
    if (!customProviders.value) {
      return null;
    }

    const ssoProvider: IdentityProviders | undefined = toValue(
      customProviders,
    )?.find((club) => {
      const normalize = (str: string) => str.replace(" ", "-").toLowerCase();

      return (
        teamName.value &&
        (normalize(teamName.value).includes(normalize(club.alternativeName)) ||
          normalize(teamName.value).includes(normalize(club.name)))
      );
    });

    return ssoProvider ?? null;
  });
};
